<div class="modal-overlay">
    <div class="modal-content">
        <span class="close-btn" (click)="fecharModal()"><i class="fa-solid fa-x fa-flip-both"></i></span>

        <button class="nav-btn left" (click)="voltar()">❮</button>

        <!-- 🔹 Imagem principal -->
        <img [src]="imagens[selectedImageIndex]" class="modal-image">

        <button class="nav-btn right" (click)="avancar()">❯</button>

        <!-- 🔹 Lista de miniaturas -->
        <div class="thumbnails">
            <img *ngFor="let img of imagens; let i = index" 
                 [src]="img" 
                 class="thumbnail" 
                 [class.active]="i === selectedImageIndex"
                 (click)="selecionarImagem(i)">
        </div>
    </div>
</div>
